import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { map } from 'rxjs';
import { ResultItem } from '../../models/result-item.model';

@Component({
  selector: 'hazmatsuite-next-result-selection',
  templateUrl: './result-selection.component.html',
  styleUrls: ['./result-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultSelectionComponent {
  @Input() items: ResultItem[] = [];
  @Output() selectResult = new EventEmitter<ResultItem>();

  public resultTranslations$ = this.languageService.translations$.pipe(
    map(translations => translations['ResultResource']));

  constructor(private languageService: LanguageService) {
    this.languageService.fetchResources(['ResultResource']);
  }

  public selectItem(item: ResultItem): void {
    this.selectResult.next(item);
  }
}
